"use client";

import Image from "./image";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { motion } from "motion/react";
import { useState } from "react";

const heroImages = [
  { src: "/assets/earth.jpg", alt: "全球城市与地球景观" },
  { src: "/assets/city.jpg", alt: "城市建筑景观" },
];

export function HeroCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);

  // 切换到下一张首屏图片。
  const nextImage = () =>
    setActiveIndex((index) => (index + 1) % heroImages.length);
  // 切换到上一张首屏图片。
  const previousImage = () =>
    setActiveIndex(
      (index) => (index - 1 + heroImages.length) % heroImages.length,
    );

  return (
    <div className="hero-carousel" aria-label="首屏图片轮播">
      <motion.div
        animate={{ x: `-${activeIndex * 100}%` }}
        className="hero-carousel-track"
        transition={{ duration: 0.48, ease: [0.22, 1, 0.36, 1] }}
      >
        {heroImages.map((image, index) => (
          <div className="hero-carousel-slide" key={image.src}>
            <Image
              src={image.src}
              alt={image.alt}
              fill
              priority={index === 0}
              sizes="100vw"
            />
          </div>
        ))}
      </motion.div>
      <div className="hero-carousel-controls">
        <span aria-live="polite">
          {String(activeIndex + 1).padStart(2, "0")} /{" "}
          {String(heroImages.length).padStart(2, "0")}
        </span>
        <button
          type="button"
          aria-label="切换上一张首屏图片"
          onClick={previousImage}
        >
          <ChevronLeft size={19} />
        </button>
        <button
          type="button"
          aria-label="切换下一张首屏图片"
          onClick={nextImage}
        >
          <ChevronRight size={19} />
        </button>
      </div>
    </div>
  );
}
